import { FormationDetailProps } from '@/types/formation';

export const hpThpFormation: FormationDetailProps = {
  id: '29',
  title: 'Formation HP/THP - Habilitation électrique pour opérations sur les installations électriques',
  description: 'Formation à l\'habilitation électrique pour les opérations sur les installations électriques haute tension (HT) et très haute tension (THT), conformément à la norme NF C18-510.',
  duration: '4 jours (28 heures)',
  category: 'Électricité',
  imageSrc: '/images/home/sdpsilogo.png',
  slug: 'hp-thp',
  reference: 'F-HPTHP',
  price: 'Sur devis – nous contacter',
  targetAudience: 'Électriciens, techniciens de maintenance, chargés d\'intervention, chefs d\'équipe travaillant sur des installations électriques HT/THT',
  prerequisites: 'Avoir des connaissances de base en électricité et une expérience professionnelle dans le domaine',
  objectives: [
    'Connaître les dangers de l\'électricité et les effets du courant électrique sur le corps humain',
    'Maîtriser les prescriptions de sécurité électrique',
    'Savoir analyser les risques électriques',
    'Connaître les procédures de consignation et de déconsignation',
    'Savoir effectuer des interventions de dépannage et des essais en toute sécurité'
  ],
  program: [
    {
      title: 'Les dangers de l\'électricité',
      items: [
        'Les effets du courant électrique sur le corps humain',
        'Les différents types de contacts électriques',
        'Les accidents d\'origine électrique',
        'Les moyens de protection contre les contacts directs et indirects'
      ]
    },
    {
      title: 'La réglementation',
      items: [
        'Les textes réglementaires (Code du travail, norme NF C18-510)',
        'Les principes généraux de prévention',
        'Le rôle des différents acteurs',
        'Les documents réglementaires (attestation de consignation, avis de fin de travail, etc.)'
      ]
    },
    {
      title: 'Les opérations sur les installations HT/THT',
      items: [
        'Les différents types d\'opérations (nettoyage, dépannage, essais, mesures, etc.)',
        'Les différents niveaux de tension et leurs spécificités',
        'Les distances de sécurité',
        'Les équipements de protection individuelle et collective'
      ]
    },
    {
      title: 'Les procédures de consignation et de déconsignation',
      items: [
        'Les principes de la consignation',
        'Les différents types de consignation',
        'Les étapes de la procédure de consignation',
        'Les vérifications à effectuer avant toute intervention'
      ]
    },
    {
      title: 'Les interventions et les essais',
      items: [
        'Les différents types d\'interventions',
        'Les précautions à prendre lors des interventions',
        'Les essais et les mesures',
        'La rédaction des comptes-rendus d\'intervention'
      ]
    }
  ],
  pedagogicalMethods: [
    'Apports théoriques',
    'Études de cas concrets',
    'Mises en situation pratiques',
    'Échanges avec les participants',
    'Support de formation remis à chaque participant'
  ],
  evaluationMethods: [
    'Évaluation théorique (QCM)',
    'Évaluation pratique (mise en situation)',
    'Questionnaire de satisfaction'
  ],
  certification: 'Attestation de formation et avis d\'habilitation électrique (délivré par l\'employeur)',
  registrationProcess: [
    'Inscription possible jusqu\'à 15 jours avant le début de la formation',
    'Groupe de 4 à 10 participants maximum',
    'Évaluation médicale obligatoire avant la formation'
  ],
  accessibilityCriteria: 'Formation accessible aux personnes en situation de handicap. Nous contacter pour adapter la formation selon les besoins spécifiques.',
  formatterInfo: {
    name: 'Sébastien DAVRAINVILLE - SDPSI Formation',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsi-formations.fr'
  }
};
